module.exports = __webpack_public_path__ + "img/render_service.16432c53.gif";